
import { TotalWallet } from './models/TotalWallet';
import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild, ViewEncapsulation, AfterViewChecked } from '@angular/core';
import { Color } from "@swimlane/ngx-charts";
import { RevalueDepositBar } from './models/RevalueDepositBar';
import { RevaluateDepositPie } from './models/RevaluateDepositPie';
import { GoldBuyPlan } from './models/GoldBuyPlan';
import { BaseComponent } from 'src/app/components/base/base.component';
import { DataSessionService } from 'src/app/services/commons/data-session.service';
import { CommonService } from 'src/app/services/commons/commons.service';
import { Router } from '@angular/router';
import { WalletService } from 'src/app/services/wallet.service';
import { UsersService } from 'src/app/services/users.service';
import { MovimentiService } from 'src/app/services/movimenti.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.scss'],
  standalone: false
})
export class DashboardPage extends BaseComponent implements OnInit, AfterViewInit, AfterViewChecked {
  @ViewChild("alertamount",{static:true, read:ElementRef}) alertAmount!:ElementRef;
  @ViewChild("alertamountSell",{static:true, read:ElementRef}) alertAmountSell!:ElementRef;

 totalWallet:TotalWallet = new TotalWallet();
 goldBuyPlan?: GoldBuyPlan;
 revaluateDepositPie:RevaluateDepositPie = new RevaluateDepositPie();
 revaluateDepositBar:RevalueDepositBar = new RevalueDepositBar();
 lingotti:string[] = [];
  grGoldTotWallet: any;
  totalBalanceTotWallet: any;
  lastMonthName: string="";
  revalLastMonth: number=0;
  PAO250: number=0;
  PAO100: number=0;
  PAO1000: number=0;
  PAO500: number=0;
  grGoldTotWalletPAO: number=0;
  revalTotal: number=0;
  grTotalGold:number =0;
  grContoOro:number =0;
  grContoOroUtenti:number =0;
  isMobile: boolean=false;
  isAdmin: boolean=false;

  soglia:number = 0;
  sogliaSell:number = 0;
  valoreTempoReale:number = 0;
  alertIsActive:boolean=false;
  alertIsActiveSell:boolean=false;
  inputIsOnFocus:boolean=false;
  inputIsOnFocusSell:boolean=false;

  constructor(private dsService:DataSessionService,
    private _commonService:CommonService,
    private walletService: WalletService,
    private dataSessionServ:DataSessionService,
    private movimentiService:MovimentiService,
    private userServ:UsersService,
    private _router: Router) {
    super(dsService, _commonService,_router);
   }

  colorScheme:any = {
    domain: ['#b18e33', '#26a17b']
  };

  selectedGold:string="";
  get compraOroTotalAmount():number {
    return eval(this.selectedGold) * this.goldValue;
  };
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }
  checkScreenSize() {
    this.isMobile = window.innerWidth <= 768;
  }
  add(){
    if(!this.alertIsActive)
      return;
    this.soglia++;
    this.saveSoglia();
  }
  remove(){
    if(!this.alertIsActive)
      return;
    if(this.soglia>0)
      this.soglia--;
    this.saveSoglia();
  }

  addSell(){
    if(!this.alertIsActiveSell)
      return;
    this.sogliaSell++;
    this.saveSogliaSell();
  }
  removeSell(){
    if(!this.alertIsActiveSell)
      return;
    if(this.sogliaSell>0)
      this.sogliaSell--;
    this.saveSogliaSell();
  }

  ngAfterViewInit() {
    const script = document.createElement('script');
    script.src = '/assets/js/chartgold.js';
    script.type = 'text/javascript';
    script.async = true;
    document.getElementById('gold-price')?.appendChild(script);
    console.log("Faaato", this.goldValue)
  }

  ngAfterViewChecked(): void {
    this.onValueChange();
  }

  saveSogliaSell(){
    if(this.loggedUser!=null){

      this.loggedUser.activeAlertSell = this.alertIsActiveSell;
      this.loggedUser.alertSell = this.sogliaSell as number;
      this.userServ.update(this.loggedUser).then(
        (resp)=>{
          if(resp.error==null)
            this._commonService.showToast("alert_value","Alert salvato con successo!",4000,"bottom","success");
          else
            this._commonService.showToast("alert_value_error","Ops! "+resp.message,4000,"bottom","danger");
        }
      );
    }

  }
  saveSoglia(){
    if(this.loggedUser!=null){

      this.loggedUser.activeAlert = this.alertIsActive;
      this.loggedUser.alert = this.soglia as number;
      this.userServ.update(this.loggedUser).then(
        (resp)=>{
          if(resp.error==null)
            this._commonService.showToast("alert_value","Alert salvato con successo!",4000,"bottom","success");
          else
            this._commonService.showToast("alert_value_error","Ops! "+resp.message,4000,"bottom","danger");
        }
      );
    }

  }
  onValueChangeSell() {

    if(!this.inputIsOnFocusSell){
      if (!this.alertAmountSell) return;
      let v = parseFloat(this.alertAmountSell.nativeElement.value as string).toFixed(2);
      //aggiungo le fee
      let val = parseFloat(v)
      val += parseFloat(this.sogliaSell.toFixed(2));
      this.alertAmountSell.nativeElement.value = v.toString();

    }

  }

  
  loadContoUser(){
    let body={
      userId: this.loggedUser?.id,
      admin: this.isAdmin
    }
      this.movimentiService.listContoOro(body).then(
        (resp)=>{
          console.log("Utente", resp)            
          this.grContoOro=resp.totalGr;
          if (this.isAdmin) this.grContoOroUtenti=resp.totalGrBuy;
        });      


  }

  onValueChange() {

    if(!this.inputIsOnFocus){
      if (!this.alertAmount) return;
      let v = parseFloat(this.alertAmount.nativeElement.value as string).toFixed(2);
      //aggiungo le fee
      let val = parseFloat(v)
      if (this.soglia) {
        val += parseFloat(this.soglia.toFixed(2));
        this.alertAmount.nativeElement.value = v.toString();
  
      }

    }

  }


  override ngOnInit() {
    super.ngOnInit();
    this.checkScreenSize();
    this.loadDashboard();
    this.getTotalWallet();
    this.getRevalDepositPie();
    this.getGoldBuyingPlan();
    this.getRevalDepositBar();
    this.getLingotti();
    this.loadContoUser();
    this.dataSessionServ.goldValue$.subscribe(
      (value:any)=>
      {
        if (value!=0) {
          if (this.loggedUser) {
            //console.log("VVVAVALLLE"  , value, this.loggedUser.activeAlertSell, this.loggedUser.activeAlert)
            if (!this.loggedUser.activeAlertSell) this.sogliaSell=value;
            if (!this.loggedUser.activeAlert) this.soglia=value;
          }
        }
        this.goldValue = value!=null?value:0;
      }

    )
    this.soglia = this.loggedUser?.alert as number;
    if (this.soglia>0) {
      if (this.loggedUser) {
        this.loggedUser.activeAlert = true;
      }
    }
    if (this.soglia==0) {
      this.soglia=this.goldValue;
    }
    if (this.sogliaSell==0) {
      this.sogliaSell=this.goldValue;
    }

    this.alertIsActive = this.loggedUser?.activeAlert as boolean;
    this.alertIsActiveSell = this.loggedUser?.activeAlertSell as boolean;
    this.onValueChange();
        this.checkScreenSize();
    this.dataSessionServ.goldValue$.subscribe((value)=>{

      this.valoreTempoReale = value as number;
    });

  }

  loadDashboard(){
    const body={
      userId: this.loggedUser?.id
    }
    this.isAdmin=this.loggedUser?.level=="admin";
    this.walletService.dashaboard(body).then(
      (result) => {

        if(result!=null){
          console.log(result)
          this.grGoldTotWallet = result.grGoldTotWalletPAO;
          this.grTotalGold = result.grtotalGold;
          this.totalBalanceTotWallet= result.totalBalanceTotWallet;
          this.revalLastMonth =result.revalLastMonth;
          this.lastMonthName= result.lastMonthName;
          this.revaluateDepositPie.lastMonthName = result.lastMonthName;
          this.revaluateDepositPie.revalLastMonth = result.revalLastMonth
          this.totalWallet=result.totalWallet;
          this.PAO100=result.PAO100;
          this.PAO250 = result.PAO250;
          this.PAO500 = result.PAO500;
          this.PAO1000 = result.PAO1000;
          this.revalTotal = result.revalTotal;


          this.getTotalWallet();
          this.getRevalDepositPie();
          this.getGoldBuyingPlan();
          this.getRevalDepositBar();
          this.getLingotti();
        }
        else
          this._commonService.showToast("dashboardError","Ops! Non sono riuscito a caricare la dashboard! Riprova tra poco.",4000,"bottom","danger");

      }
    )
  }

  getTotalWallet(){
  /*{
        name : "Oro",
        value : 543
      }*/
     this.totalWallet = new TotalWallet();
     this.totalWallet.view = [500, 200];
     this.totalWallet.scheme = this.colorScheme;
     this.totalWallet.label = "label";
     this.totalWallet.result = [{
      name : "Oro",
      value : this.grGoldTotWallet
    }]
    this.totalWallet.grGoldTotWallet = this.grGoldTotWallet;
    this.totalWallet.totalBalanceTotWallet = this.totalBalanceTotWallet;
  }
  getRevalDepositPie(){
    this.revaluateDepositPie.scheme = {
      domain: ['#b18e33', '#000000']
    } as Color;
    this.revaluateDepositPie.view = [500, 200];
    //this.revaluateDepositPie.scheme = this.colorScheme;
    this.revaluateDepositPie.label = "label";
    this.revaluateDepositPie.revalLastMonth = this.revalLastMonth;
    this.revaluateDepositPie.lastMonthName =this.lastMonthName;
    this.revaluateDepositPie.result = [
      {
        name : "Rivalutazione "+this.revaluateDepositPie.lastMonthName,
        value : this.revaluateDepositPie.revalLastMonth
      },
      {
        name : "Rivalutazione totali 2",
        value : this.revalTotal
      }]
  }
  getGoldBuyingPlan() {
    this.goldBuyPlan = new GoldBuyPlan()

    this.goldBuyPlan.scheme = {
      domain: ['#b18e33', '#000000']
    } as Color;
    this.goldBuyPlan.view = [500, 200];
    //this.revaluateDepositPie.scheme = this.colorScheme;
    this.goldBuyPlan.label = "label";
    this.goldBuyPlan.PAO100 =parseFloat(this.PAO100.toFixed(2));
    this.goldBuyPlan.PAO250 = parseFloat(this.PAO250.toFixed(2));
    this.goldBuyPlan.PAO500 = parseFloat(this.PAO500.toFixed(2));
    this.goldBuyPlan.PAO1000 = parseFloat(this.PAO1000.toFixed(2));
    this.goldBuyPlan.TotBalanceGrGold = this.grGoldTotWallet;

    this.goldBuyPlan.result = [
      {
        name : "Val",
        value : 100
      }
    ]
  }
  getRevalDepositBar(){
    this.revaluateDepositBar.scheme = {
      domain: ['#b18e33', '#26a17b']
    } as Color;
    this.revaluateDepositBar.view = [200, 150];
    this.revaluateDepositBar.results = [{
      name:"2010",
      value:7
    },
    {
      name:"2011",
      value:8
    },
    {
      name:"2012",
      value:6
    },
    {
      name:"2013",
      value:6
    },
    {
      name:"2014",
      value:6
    }]
    this.revaluateDepositBar.multi = [
      {
        name:"",
        series:this.revaluateDepositBar.results
      }];
  }
  getLingotti(){
    this.lingotti = ["100", "250", "500"];
    this.selectedGold = "100";
    //this.compraOroTotalAmount = 7400;
  }

  percentageFormatting(c:any) {
    //per avere solo due cifre decimali dopo lo zero
    return c?.toFixed(2);
  }
  valueFormatting(value:number):string{

    return value?.toFixed(2);
  }
  onSelect(event:any) {
    console.log(event);
  }
  onActivate(data:any): void {
    console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data:any): void {
    console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }
}
